import script from "./MultiAudioUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiAudioUpload.vue?vue&type=script&setup=true&lang=ts"

import "./MultiAudioUpload.vue?vue&type=style&index=0&id=5cf900fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cf900fd"]])

export default __exports__